// import {
//     Avatar,
//     Box,
//     Badge,
//     Card,
//     CardContent,
//     List,
//     ListItem,
//     ListItemButton,
//     ListItemAvatar,
//     ListItemText,
//     Typography,
//     Fade,
//     Grid
// } from '@mui/material';

// import { IconArrowLeft, IconArrowRight } from '@tabler/icons';
// import React, { useState, useEffect } from 'react';

// function formatConversationTimestamp(isoString) {
//     const date = new Date(isoString);

//     // sempre ajusta para o fuso de São Paulo
//     const options = { timeZone: 'America/Sao_Paulo' };
//     const today = new Date().toLocaleDateString('pt-BR', options);
//     const yesterday = new Date(Date.now() - 86400000).toLocaleDateString('pt-BR', options); // -1 dia

//     const dateStr = date.toLocaleDateString('pt-BR', options);

//     if (dateStr === today) {
//         // se for hoje → retorna HH:mm
//         return date.toLocaleTimeString('pt-BR', {
//             ...options,
//             hour: '2-digit',
//             minute: '2-digit'
//         });
//     } else if (dateStr === yesterday) {
//         // se for ontem → retorna "ontem"
//         date.toLocaleTimeString('pt-BR', {
//             ...options,
//             hour: '2-digit',
//             minute: '2-digit'
//         });
//         return `ontem ás ${date.toLocaleTimeString('pt-BR', {
//             ...options,
//             hour: '2-digit',
//             minute: '2-digit'
//         })}`;
//     } else {
//         // se for antes de ontem → retorna só dia/mês
//         return date.toLocaleDateString('pt-BR', {
//             ...options,
//             day: '2-digit',
//             month: '2-digit'
//         });
//     }
// }

// function stringToColor(string) {
//     let hash = 0;
//     let i;

//     /* eslint-disable no-bitwise */
//     for (i = 0; i < string.length; i += 1) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }

//     let color = '#';

//     for (i = 0; i < 3; i += 1) {
//         const value = (hash >> (i * 8)) & 0xff;
//         color += `00${value.toString(16)}`.slice(-2);
//     }
//     /* eslint-enable no-bitwise */

//     return color;
// }

// function stringAvatar(name) {
//     return {
//         sx: {
//             bgcolor: stringToColor(name)
//         },
//         children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
//     };
// }

// const DealCard = ({ deal, onClick }) => {
//     const conversation = deal.conversation_detail;
//     // console.log(`conversation: ${JSON.stringify(conversation)}`);

//     // useEffect(() => {
//     // console.log('entrou no useefect');
//     // console.log(`useefect - conversation: ${JSON.stringify(conversation)}`);
//     // console.log(`deal: ${JSON.stringify(deal)}`);
//     // }, [deal]);

//     // console.log(`DealConversationCard - deal:${JSON.stringify(deal)}`);

//     return (
//         <Card
//             onClick={onClick}
//             sx={{
//                 p: 0.5,
//                 m: 0,
//                 minHeight: 120,
//                 width: '100%',
//                 background: '#DADADC', //EBEBED //#3b3737
//                 cursor: 'pointer',
//                 mb: 1,
//                 boxSizing: 'border-box',
//                 '&:hover': { backgroundColor: '#D5D5D9' }
//             }}
//         >
//             <CardContent
//                 sx={{
//                     p: 0,
//                     '&:last-child': {
//                         pb: 0
//                     }
//                 }}
//             >
//                 <Box display="flex" alignItems="center" gap={1}>
//                     {deal.title === '' && <Avatar {...stringAvatar(deal.title)} />}

//                     <Box flex={1}>
//                         {/* <Typography variant="body2" fontWeight="bold">
//                             <Badge badgeContent={conversation.qtdUnread} color="success">
//                                 <Typography color="#0C0C0D">{conversation.displayName}</Typography>
//                             </Badge>
//                         </Typography> */}

//                         <Box display="flex" alignItems="center" gap={0.5}>
//                             {/* {conversation.type_author_last_message === 'user' && <IconArrowLeft fontSize="small" />}
//                             {conversation.type_author_last_message === 'agent' && <IconArrowRight fontSize="small" />} */}

//                             {/* <Typography variant="body2" color="textSecondary" noWrap>
//                                 <Typography color="#0C0C0D">{conversation.last_message || 'Sem última mensagem'}</Typography>
//                             </Typography> */}
//                         </Box>

//                         <Box display="flex" ml={2} mt={2} textAlign="left">
//                             <Typography>{deal.title}</Typography>
//                             <Typography>{deal.description}</Typography>
//                             {/* <Typography variant="caption" color="#0C0C0D">
//                                 {formatConversationTimestamp(conversation.last_message_time)}
//                             </Typography> */}
//                             {/* <Avatar sx={{ width: 28, height: 28, marginLeft: 11 }} src={`/${conversation.type}_icon.png`} /> */}
//                         </Box>

//                         <Typography color="#0C0C0D" ml={2} variant="body2" noWrap>
//                             R$ {deal.value || '-'}
//                         </Typography>
//                     </Box>
//                 </Box>
//             </CardContent>
//         </Card>
//     );
// };

// export default DealCard;

// import {
//     Avatar,
//     Box,
//     Badge,
//     Card,
//     CardContent,
//     List,
//     ListItem,
//     ListItemButton,
//     ListItemAvatar,
//     ListItemText,
//     Typography,
//     Fade,
//     Grid
// } from '@mui/material';

// import { IconArrowLeft, IconArrowRight } from '@tabler/icons';
// import React, { useState, useEffect } from 'react';

// function formatConversationTimestamp(isoString) {
//     const date = new Date(isoString);

//     // sempre ajusta para o fuso de São Paulo
//     const options = { timeZone: 'America/Sao_Paulo' };
//     const today = new Date().toLocaleDateString('pt-BR', options);
//     const yesterday = new Date(Date.now() - 86400000).toLocaleDateString('pt-BR', options); // -1 dia

//     const dateStr = date.toLocaleDateString('pt-BR', options);

//     if (dateStr === today) {
//         // se for hoje → retorna HH:mm
//         return date.toLocaleTimeString('pt-BR', {
//             ...options,
//             hour: '2-digit',
//             minute: '2-digit'
//         });
//     } else if (dateStr === yesterday) {
//         // se for ontem → retorna "ontem"
//         date.toLocaleTimeString('pt-BR', {
//             ...options,
//             hour: '2-digit',
//             minute: '2-digit'
//         });
//         return `ontem ás ${date.toLocaleTimeString('pt-BR', {
//             ...options,
//             hour: '2-digit',
//             minute: '2-digit'
//         })}`;
//     } else {
//         // se for antes de ontem → retorna só dia/mês
//         return date.toLocaleDateString('pt-BR', {
//             ...options,
//             day: '2-digit',
//             month: '2-digit'
//         });
//     }
// }

// function stringToColor(string) {
//     let hash = 0;
//     let i;

//     /* eslint-disable no-bitwise */
//     for (i = 0; i < string.length; i += 1) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }

//     let color = '#';

//     for (i = 0; i < 3; i += 1) {
//         const value = (hash >> (i * 8)) & 0xff;
//         color += `00${value.toString(16)}`.slice(-2);
//     }
//     /* eslint-enable no-bitwise */

//     return color;
// }

// function stringAvatar(name) {
//     return {
//         sx: {
//             bgcolor: stringToColor(name)
//         },
//         children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`
//     };
// }

// const DealConversationCard = ({ deal, onClick }) => {
//     const conversation = deal.conversation_detail;

//     if (!conversation) return null;

//     return (
//         <Card
//             onClick={onClick}
//             sx={{
//                 p: 0.5,
//                 m: 0,
//                 minHeight: 120,
//                 width: '100%',
//                 background: '#DADADC', //EBEBED //#3b3737
//                 cursor: 'pointer',
//                 mb: 1,
//                 boxSizing: 'border-box',
//                 '&:hover': { backgroundColor: '#D5D5D9' }
//             }}
//         >
//             <CardContent
//                 sx={{
//                     p: 0,
//                     '&:last-child': {
//                         pb: 0
//                     }
//                 }}
//             >
//                 <Box display="flex" alignItems="center" gap={1}>
//                     {conversation.avatarUrl === '' && <Avatar {...stringAvatar(conversation.displayName)} />}
//                     {conversation.avatarUrl !== '' && <Avatar src={conversation.avatarUrl} />}
//                     {/* <Avatar src={conversation.avatarUrl} /> */}

//                     {/* <Box textAlign="center"> */}

//                     {/* <Typography variant="caption">{conversation.type}</Typography> */}
//                     {/* </Box> */}

//                     <Box flex={1}>
//                         <Typography variant="body2" fontWeight="bold">
//                             <Badge badgeContent={conversation.qtdUnread} color="success">
//                                 <Typography color="#0C0C0D">{conversation.displayName}</Typography>
//                             </Badge>
//                         </Typography>

//                         <Box display="flex" alignItems="center" gap={0.5}>
//                             {conversation.type_author_last_message === 'user' && <IconArrowLeft fontSize="small" />}
//                             {conversation.type_author_last_message === 'agent' && <IconArrowRight fontSize="small" />}

//                             <Typography variant="body2" color="textSecondary" noWrap>
//                                 <Typography color="#0C0C0D">{conversation.last_message || 'Sem última mensagem'}</Typography>
//                             </Typography>
//                         </Box>
//                         <Typography color="#0C0C0D" variant="body2" noWrap>
//                             R$ {deal.value || '-'}
//                         </Typography>

//                         <Box display="flex" textAlign="left">
//                             <Typography variant="caption" color="#0C0C0D">
//                                 {formatConversationTimestamp(conversation.last_message_time)}
//                             </Typography>
//                             <Avatar sx={{ width: 28, height: 28, marginLeft: 11 }} src={`/${conversation.type}_icon.png`} />
//                         </Box>
//                     </Box>
//                 </Box>
//             </CardContent>
//         </Card>
//     );
// };

// export default DealConversationCard;

import { Avatar, Box, Badge, Card, CardContent, Typography } from '@mui/material';

import { IconArrowLeft, IconArrowRight } from '@tabler/icons';
import React from 'react';

function formatConversationTimestamp(isoString) {
    const date = new Date(isoString);

    const options = { timeZone: 'America/Sao_Paulo' };
    const today = new Date().toLocaleDateString('pt-BR', options);
    const yesterday = new Date(Date.now() - 86400000).toLocaleDateString('pt-BR', options);

    const dateStr = date.toLocaleDateString('pt-BR', options);

    if (dateStr === today) {
        return date.toLocaleTimeString('pt-BR', {
            ...options,
            hour: '2-digit',
            minute: '2-digit'
        });
    } else if (dateStr === yesterday) {
        return `ontem às ${date.toLocaleTimeString('pt-BR', {
            ...options,
            hour: '2-digit',
            minute: '2-digit'
        })}`;
    } else {
        return date.toLocaleDateString('pt-BR', {
            ...options,
            day: '2-digit',
            month: '2-digit'
        });
    }
}

function stringToColor(string) {
    let hash = 0;

    for (let i = 0; i < string.length; i += 1) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (let i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }

    return color;
}

function stringAvatar(name) {
    const parts = name.split(' ');
    return {
        sx: {
            bgcolor: stringToColor(name)
        },
        children: `${parts[0]?.[0] || ''}${parts[1]?.[0] || ''}`
    };
}

const DealCard = ({ deal, onClick }) => {
    // const conversation = deal.conversation_detail;
    // if (!conversation) return null;

    return (
        <Card
            onClick={onClick}
            sx={{
                borderRadius: '22px',
                cursor: 'pointer',
                mb: 1.5,
                border: '1px solid rgba(110,220,255,0.12)',
                background: `
                    linear-gradient(180deg, rgba(18,44,72,0.45), rgba(6,16,28,0.65))
                `,
                backdropFilter: 'blur(14px)',
                boxShadow: `
                    0 0 20px rgba(0,180,255,0.08),
                    inset 0 0 18px rgba(120,220,255,0.03),
                    inset 0 1px 0 rgba(255,255,255,0.05)
                `,
                transition: 'all 0.25s ease',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    border: '1px solid rgba(140,240,255,0.35)',
                    boxShadow: `
                        0 0 30px rgba(0,200,255,0.16),
                        inset 0 0 25px rgba(120,220,255,0.06)
                    `
                }
            }}
        >
            <CardContent
                sx={{
                    p: 2,
                    '&:last-child': { pb: 2 }
                }}
            >
                <Box display="flex" alignItems="center" gap={1.5}>
                    {/* Avatar */}
                    {/* {conversation.avatarUrl === '' ? (
                        <Avatar
                            {...stringAvatar(conversation.displayName)}
                            sx={{
                                width: 42,
                                height: 42,
                                boxShadow: '0 0 10px rgba(0,180,255,0.3)'
                            }}
                        />
                    ) : (
                        <Avatar
                            src={conversation.avatarUrl}
                            sx={{
                                width: 42,
                                height: 42,
                                boxShadow: '0 0 10px rgba(0,180,255,0.3)'
                            }}
                        />
                    )} */}

                    <Box flex={1}>
                        {/* Nome + badge */}
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            {/* <Badge
                                badgeContent={conversation.qtdUnread}
                                sx={{
                                    '& .MuiBadge-badge': {
                                        background: 'rgba(120,240,255,0.9)',
                                        color: '#001018',
                                        boxShadow: '0 0 10px rgba(120,240,255,0.8)'
                                    }
                                }}
                            >
                                <Typography
                                    sx={{
                                        fontSize: 15,
                                        fontWeight: 500,
                                        color: 'rgba(255,255,255,0.92)'
                                    }}
                                >
                                    {conversation.displayName}
                                </Typography>
                            </Badge> */}

                            {/* <Typography
                                sx={{
                                    fontSize: 11,
                                    color: 'rgba(255,255,255,0.45)'
                                }}
                            >
                                {formatConversationTimestamp(conversation.last_message_time)}
                            </Typography> */}
                        </Box>

                        {/* Última mensagem */}
                        {/* <Box display="flex" alignItems="center" gap={0.6} mt={0.5}>
                            {conversation.type_author_last_message === 'user' && <IconArrowLeft size={14} color="#7ee7ff" />}
                            {conversation.type_author_last_message === 'agent' && <IconArrowRight size={14} color="#7ee7ff" />}

                            <Typography
                                sx={{
                                    fontSize: 13,
                                    color: 'rgba(255,255,255,0.65)',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                            >
                                {conversation.last_message || 'Sem mensagem'}
                            </Typography>
                        </Box> */}

                        {/* Valor + tipo */}
                        <Box display="flex" alignItems="center" justifyContent="space-between" mt={1}>
                            <Typography
                                sx={{
                                    fontSize: 13,
                                    color: 'rgba(180,245,255,0.85)'
                                }}
                            >
                                R$ {deal.value || '-'}
                            </Typography>

                            {/* <Avatar
                                sx={{
                                    width: 26,
                                    height: 26,
                                    border: '1px solid rgba(120,220,255,0.2)',
                                    background: 'rgba(20,40,60,0.6)'
                                }}
                                src={`/${conversation.type}_icon.png`}
                            /> */}
                        </Box>
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default DealCard;
